import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { injectTranslate } from '@core/i18n-legacy';
import { LoginType } from '@core/tellent-types';
import {
  IconComponent,
  InputComponent,
  OverlayOriginDirective,
  SelectComponent,
} from '@core/user-interface-legacy';

interface LoginTypeOption {
  value: LoginType;
  label: string;
  heading: string;
  subheading: string;
}

@Component({
  selector: 'tlc-login-type-select',
  templateUrl: './login-type-select.component.html',
  styleUrl: './login-type-select.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    InputComponent,
    OverlayOriginDirective,
    IconComponent,
    SelectComponent,
    ReactiveFormsModule,
  ],
})
export class LoginTypeSelectComponent {
  private readonly t = injectTranslate();

  public loginTypeControl = input.required<FormControl<LoginType | null>>();

  public options: LoginTypeOption[] = [
    {
      value: LoginType.Auto,
      label: this.t('tlc.members.add_member.member_details_form.login_type.dropdown.auto.label'),
      heading: this.t(
        'tlc.members.add_member.member_details_form.login_type.dropdown.auto.heading',
      ),
      subheading: this.t(
        'tlc.members.add_member.member_details_form.login_type.dropdown.auto.subheading',
      ),
    },
    {
      value: LoginType.Custom,
      label: this.t('tlc.members.add_member.member_details_form.login_type.dropdown.custom.label'),
      heading: this.t(
        'tlc.members.add_member.member_details_form.login_type.dropdown.custom.heading',
      ),
      subheading: this.t(
        'tlc.members.add_member.member_details_form.login_type.dropdown.custom.subheading',
      ),
    },
  ];
}
